<template>
    <ion-header class="menu-header" mode="md">
        <ion-toolbar class="main-menu" color="background-transparent" mode="md" >
            <div class="nav-menu">
                <div class="home-title-container image-and-text-title-container" v-if="pageTitle.length > 0">
                    <ion-icon v-if="imgSrc" :src="imgSrc" class="title-image" />
                    <span>{{ pageTitle }}</span>
                </div>
                
                <ion-icon @click="returnHome" :icon="homeSharp" class="left-home-image" v-if="!isHomeScreen"/>
                <ion-icon id="mainMenuBackBtn" v-show="!pageLoading" @click="routeBack" :icon="chevronBack" class="home-image back-button" v-if="!isHomeScreen"/>
                <ion-title class="nav-title">
                    <div class="title-container" v-if="!shouldShowIcon">
                        <ion-icon v-if="imgSrc"  :src="imgSrc" class="title-image" />
                    </div>
                </ion-title>
                
                <div>
                    <ion-icon @click="goToCalculator" :icon="lockClosed" mode="md" 
                        class="home-image"
                        :class="calculatorVisibilityClass"
                    />
                </div>
                
                <ion-buttons slot="end">
                    <ion-menu-button auto-hide="false" @click="openMainMenu"></ion-menu-button>
                </ion-buttons>
                
            </div>
        </ion-toolbar>
    </ion-header>
        <ion-content style="display: none;">
            <input
            ref="encryptedFileInput"
            class="hidden-input"
            type="file"
            id="encryptedFile"
            accept="text/plain,.bin"
            @click="setShouldExitApp"
            @change="importJourneySets($event, true)"
            multiple
        />
        </ion-content>

</template>

<script lang="ts">
import {
    IonContent,
    //IonHeader,
    //IonHeader,
    IonToolbar,
    IonMenu,
    IonTitle,
    IonMenuButton,
    IonButtons,
    IonItem,
    IonList,
    IonIcon,
    IonMenuToggle,
    menuController,
    modalController
} from "@ionic/vue";
import {computed, defineComponent, onBeforeMount, ref} from "vue";
import { useRouter } from "vue-router";
import { chevronDown, chevronUp,chevronBack, person, shareSocial, heart, documentTextSharp, closeSharp, homeSharp, leaf, save, cloudDownload, exit, sparkles, calculatorSharp ,keypad, lockClosed , appsOutline, home, build ,bug} from "ionicons/icons";
import translate from "../views/translate";
import {
    createLoadSpinner,
    readAndSaveJourneySets
} from "@/services/ShareService";
import { openBigPicturePagesModal,openMenuModal } from "@/services/InformationPagesService";
import { useStore } from "vuex";
import {downloadAPK, getFromS3} from "@/services/AWSService";
import { connectToInternetAlert} from "@/utilities/Alerts";
import {ActionSheetBuilder} from "@/utilities/ActionSheetBuilder";
import { AlertBuilder } from "@/utilities/AlertBuilder";
import {isValidJourneySetFilename, getJourneySetImportErrors} from "@/utilities/JourneySet";
import {getDBVersion,reloadManifestMetaData} from "@/storage/DataStorage";
import {checkAndRequestStoragePermission, deleteAndroidFiles, deleteApp ,shareFile, readJSONFileFromDataDirectory , dataDirectoryFileExists} from "@/utilities/Filesystem";
import {getImageDataUri} from "@/utilities/Compatibility";
import { ChipletButton } from "@/types/types";


export default defineComponent({
    name: "main-menu",
    props: ["pageTitle", "imgSrc" , "currentRoute" ],
    components: {
        IonContent,
        IonToolbar,
        IonTitle,
        IonButtons,
        IonMenuButton,
        IonIcon,
    },
    
    setup(props: any) {
        const { t } = translate();
        const store = useStore();
        const localeMessages = computed(() => store.getters.getLocaleMessages());
        const menuOrder = ["coach",
            "import",
            "topics",
            "training",
            "bigpicture",
            "security",
            "update",
            "cleanup",
            "uninstall",
            "privacy",
            "sharelog"];
        const isMenuOpen = ref(false);
        const dynamicSide = computed(() => t("messages.language.textDirection") === "ltr" ? "end" : "start");
        const showUnencrypted = computed(() => process.env.NODE_ENV === "development");
        const expandFindMore = ref(false);
        const showSettings = ref(false);
        const showBigPicture = computed(() => t("messages.buildConfigs.config.bigPic") === "true");
        const showLearnMore = computed(() => t("messages.buildConfigs.config.learnMore") === "true");
        const showMoreTopics = computed(() => t("messages.buildConfigs.config.moreTopics") === "true");
        const showFindMore = computed(() => showBigPicture.value || showLearnMore.value || showMoreTopics.value);
        const showAllQuadrants = computed(() => store.getters.showAllQuadrants());
        const platform = ref('');
        const isOfflineAndroid = computed(() => platform.value === "android" && t("messages.buildConfigs.config.appStoreBuild") !== "true")
        const router = useRouter();
        const route = computed(() => router.currentRoute.value);
        const isHomeScreen = computed(() => route.value.name === "fields");
        const shouldShowIcon = computed(() => route.value.name === "fields" || route.value.name === "coach" || route.value.name === "security" || route.value.name === "privacy" );
        const bigPictureIcon = computed(() => getImageDataUri(store.getters.getLocaleMessages().menu.bigPictureIcon));
        const moreTopicsIcon = computed(() => getImageDataUri(store.getters.getLocaleMessages().menu.moreTopicsIcon));
        const learnMoreIcon = computed(() => getImageDataUri(store.getters.getLocaleMessages().menu.learnMoreIcon));
        const calculatorVisibilityClass = computed(() => {
            return store.state.shouldShowCalculatorIcon ? "calculator-icon-visible" : "calculator-icon-hidden";
        });
        const mainMenuButtons: ChipletButton[] = [];
        const encryptedFileInput = ref<HTMLInputElement | null>(null);
        const pageLoading = computed(() => store.state.pageLoading);
        const logExists = computed(() => dataDirectoryFileExists("applog.txt"));
        
        const closeMainMenu = async() => {
            const existingModal = await modalController.getTop();
            if (existingModal && existingModal.id === "menu-modal") {
                await modalController.dismiss(undefined, undefined, "menu-modal");
            }
        }
        
        const toggleFindMore = () => {
            showSettings.value = false;
            expandFindMore.value = !expandFindMore.value;
        };

        const toggleSettings = () => {
            expandFindMore.value = false;
            showSettings.value = !showSettings.value;
        };

        const closeSubMenus = () => {
            expandFindMore.value = false;
            showSettings.value = false;
        };
        

        const returnHome = async () => {
            await menuController.close();
            await router.push({ name: `fields` });

        };

        const routeBack = async() => {
            
            const lastRoute = store.getters.getLastVisitedRoute();
            await store.dispatch("popRouteHistory" , lastRoute);
            await store.dispatch("addRouteHistory" , route.value.fullPath);
            await router.push(lastRoute);
            
        }

        const goToCalculator = () => {
            router.push({ name: `calculator` });
        }

        const goToPrivacy = () => {
            router.push({ name: `privacy` });
        };

        const goToLearnMore = () => {
            router.push({ name: "learn-more", params: { fieldId: "jf5" } });
        };

        const goToMoreTopics = () => {
            router.push({ name: "more-topics", params: { fieldId: "jf6" } });
        };

        const goToSecurity = () => {
            router.push({ name: `security` });
        };

        const goToCoach = () => {
            router.push({ name: `coach` });
        };
        
        const askToUpdate = async () => {
            const alert = new AlertBuilder('custom-alert', `<p>${t('messages.application.updateApp')}</p>`)
                .addNoButton()
                .addYesButton(async () => {
                    const loading = await createLoadSpinner();
                    await loading.present();
                    await downloadAPK(false);
                    await loading.dismiss();
                });
            await alert.present();
        }
        //This function should maybe be moved and expanded to handle all checks for updates (online apps launch as well as being triggered from the menu)?
        const checkForUpdates = async () => {
            const result = await getFromS3(t('messages.language.variant'), `appVersion.txt?timestamp=${new Date().getTime()}`, 'text');
            const mostRecentAppVersion = result.data;
            store.dispatch("setSecureUpdateOverride" , true);
            await reloadManifestMetaData();
            //await reloadLanguage();
            store.dispatch("setSecureUpdateOverride" , false);
            if (getDBVersion() < parseInt(mostRecentAppVersion, 10)) {
                await askToUpdate();
            } else {
                const alert = new AlertBuilder('custom-alert', `<p>${t('messages.application.noUpdatesAvailable')}</p>`).addOkButton();
                await alert.present();
            }
        }
        
        const checkForUpdatesPreCheck = async () => {
            const shouldDisplayInternetAlert = await connectToInternetAlert(async () => {
                await checkForUpdates();
            });
            if (!shouldDisplayInternetAlert) {
                await checkForUpdates();
            }
        }

        const setShouldExitApp = async () => {
            await store.dispatch("setJourneySetImporting", true);
            if(store.getters.platform() === "android"){
                if(await checkAndRequestStoragePermission()){
                    await store.dispatch("setShouldExitApp", false);
                    return true;
                }else{
                    return false;
                }
            }
            await store.dispatch("setShouldExitApp", false);
            return true;
        };
        
        const importJourneySets = async (event: any, shouldDecrypt: boolean) => {
            await store.dispatch("setShouldExitApp", true);
            await store.dispatch("setJourneySetImporting", false);
            let showSuccessMessage = false;
            if (event.target.files.length > 0) {
                const loading = await createLoadSpinner();
                await loading.present();
                let error = '';
                for (const file of event.target.files) {
                    let fileError = '';
                    if (isValidJourneySetFilename(file.name)) {
                        try {
                            await new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.readAsText(file, "UTF-8");
                                reader.onload = async (setToBeAdded) => {
                                    try {
                                        const journeySet = JSON.parse(setToBeAdded?.target?.result as string);
                                        const importErrors = getJourneySetImportErrors(journeySet);
                                        if (importErrors === '') {
                                            await readAndSaveJourneySets(journeySet, shouldDecrypt);
                                            showSuccessMessage = true;
                                            resolve(true);
                                            return;
                                        }
                                        fileError = importErrors.replace('[%filename]', file.name);
                                        reject("invalid");
                                    } catch (e) {
                                        fileError = t('messages.application.importErrorProcessing').replace('[%filename]', file.name);
                                        reject("error");
                                    }
                                };
                                reader.onerror = function(evt) {
                                    fileError = t('messages.application.importErrorReading').replace('[%filename]', file.name);
                                    // TODO: MAYBE SOME AWS LOGGING SOMETIME DOWN THE ROAD?
                                    reject(evt?.target?.result);
                                };
                            });
                        } catch (e) {
                            await loading.dismiss();
                            fileError = fileError ?? t('messages.application.importErrorProcessing').replace('[%filename]', file.name);
                        }
                    } else {
                        error = t('messages.application.importInvalidFile').replace('[%filename]', file.name);
                    }
                    error += fileError ? fileError + '<br /><br />' : '';
                }
                if (error) {
                    const alert = new AlertBuilder('custom-alert', error).addCancelButton();
                    await alert.present();
                } else if (showSuccessMessage) {
                    const alert = new AlertBuilder('custom-alert', 
                `<p>${t("messages.application.successfulImport")}</p>
                        <p>${t("messages.application.deleteSet")}</p>`).addCancelButton();
                    await alert.present();
                    
                    // need to reload the page to get new journey sets
                    if (["journey-sets", "more-topics", "learn-more"].includes(route.value.name as string)) {
                        router.push({name: 'fields'});
                    }
                }
                await loading.dismiss();
            }
            event.target.value = '';
        };
    
        const triggerEncryptedFileInput = () => {
            encryptedFileInput.value?.click(); // Simulate a click on the hidden file input
        };

        async function handleShareApp() {
            const actionSheetBuilder = new ActionSheetBuilder('');
            await actionSheetBuilder.buildShareOrSaveApp();
            const actionSheet = await actionSheetBuilder.create();
            await actionSheet.present();
        }
        const shareErrorLog = async () => {
            try {
                const fileName = "applog.txt";
                if (await dataDirectoryFileExists(fileName)) {
                    const fileContent = await readJSONFileFromDataDirectory(fileName,true);
                    await shareFile(fileName, fileContent, true, "plain/text");
                } else {
                    console.error("Error log file not found"); ``
                }
            } catch (error: any) {
                console.error("Error sharing error log: " + error.message);
            }
        }

        const allMenuButtons: ChipletButton[] = [
                {
                    icon: "assets/img/person.svg",
                    label: localeMessages.value.menu.findCoach,
                    name: "coach",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: () => {
                        closeMainMenu();
                        goToCoach();
                    }
                },
                {
                    icon: bigPictureIcon.value,
                    label: localeMessages.value.menu.bigPicture,
                    name: "bigpicture",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: () => {
                        closeMainMenu();
                        openBigPicturePagesModal(localeMessages.value);
                    }
                },
                {
                    icon: moreTopicsIcon.value,
                    label: localeMessages.value.menu.moreTopics,
                    name: "topics",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: () => {
                        closeMainMenu();
                        goToMoreTopics();
                    }
                },
                {
                    icon: learnMoreIcon.value,
                    label: localeMessages.value.menu.learnMore,
                    name: "training",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: () => {
                        closeMainMenu();
                        goToLearnMore();
                    }
                },
                {
                    icon: "assets/img/systemUpdate.svg",
                    label: localeMessages.value.menu.import,
                    name: "import",
                    visibilityClass: "",
                    fileInputRef: encryptedFileInput,
                    handler: () => {
                        closeMainMenu();
                        triggerEncryptedFileInput();
                    }
                },
                {
                    icon: "assets/img/lock.svg",
                    label: localeMessages.value.menu.security,
                    name: "security",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: () => {
                        closeMainMenu();
                        goToSecurity();
                    }
                },
                {
                    icon: "assets/img/privacy.svg",
                    label: localeMessages.value.menu.privacy,
                    name: "privacy",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: () => {
                        closeMainMenu();
                        goToPrivacy();
                    }
                },
                {
                    icon: cloudDownload,
                    label: localeMessages.value.menu.checkForUpdates,
                    name: "update",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: async () => {
                        closeMainMenu();
                        await checkForUpdatesPreCheck();
                    }
                },
                {
                    icon: sparkles,
                    label: localeMessages.value.menu.cleanFiles,
                    name: "cleanup",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: async () => {
                        closeMainMenu();
                        await deleteAndroidFiles();
                    }
                },
                {
                    icon: exit,
                    label: localeMessages.value.menu.uninstall,
                    name: "uninstall",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: async () => {
                        closeMainMenu();
                        await deleteApp();
                    }
                },
                {
                    icon: bug,
                    label: "Share App Log",
                    name: "sharelog",
                    visibilityClass: "",
                    fileInputRef: undefined,
                    handler: async () => {
                        closeMainMenu();
                        await shareErrorLog();
                    }
                },
        ];

        const getItemstoRemove = async (): Promise<string[]> => {
            const toRemove = [];
            if (!isOfflineAndroid.value){
                toRemove.push("cleanup");
                toRemove.push("uninstall")
                toRemove.push("update");
            }
            if (!showBigPicture.value) toRemove.push("bigpicture") ;
            if (!showLearnMore.value && !showAllQuadrants.value)  toRemove.push("training") ;
            if (!showMoreTopics.value && !showAllQuadrants.value)  toRemove.push("topics") ;
            if(!localeMessages.value.menu.findCoach || localeMessages.value.menu.findCoach.trim() === "") toRemove.push("coach");
           // platform.value === "web" || 
            if(store.state.logLevel == 0 || !dataDirectoryFileExists("applog.txt")) toRemove.push("sharelog");
            return toRemove;
        }

        const buildMenuButtons = async () => {
            const toRemove = await getItemstoRemove();
            const filteredMenu =  menuOrder.filter(menuOption => !toRemove.includes(menuOption));
            
            filteredMenu.forEach(menuOption => {
                const thisButton = allMenuButtons.find(button => button.name === menuOption);
                if(thisButton){
                    mainMenuButtons.push(thisButton);
                }
            });
        }
        
        const openMainMenu = async () => {
            await openMenuModal(mainMenuButtons,"main-menu-modal","");
        }

        onBeforeMount(async () => {
            platform.value = await store.getters.platform();
            buildMenuButtons();
        })

        return {
            t,
            toggleFindMore,
            expandFindMore,
            toggleSettings,
            showSettings,
            chevronDown,
            chevronUp,
            chevronBack,
            calculatorSharp,
            person,
            shareSocial,
            heart,
            save,
            documentTextSharp,
            lockClosed,
            //toggleMenu,
            isMenuOpen,
            closeSharp,
            closeSubMenus,
            homeSharp,
            returnHome,
            routeBack,
            shouldShowIcon,
            isHomeScreen,
            goToPrivacy,
            goToLearnMore,
            goToMoreTopics,
            goToCoach,
            goToSecurity,
            goToCalculator,
            leaf,
            openBigPicturePagesModal,
            localeMessages,
            importJourneySets,
            setShouldExitApp,
            showFindMore,
            showBigPicture,
            showLearnMore,
            showMoreTopics,
            shareAppText: computed(() => platform.value === "ios" || store.getters.getLocaleMessages().buildConfigs.config.appStoreBuild === 'true' ? t("messages.application.shareAppOnly"): t("messages.menu.shareApp")),
            handleShareApp,
            dynamicSide,
            showUnencrypted,
            cloudDownload,
            checkForUpdatesPreCheck,
            isOfflineAndroid,
            calculatorVisibilityClass,
            showAllQuadrants,
            platform,
            exit,
            sparkles,
            deleteApp,
            deleteAndroidFiles,
            bigPictureIcon,
            moreTopicsIcon,
            learnMoreIcon,
            encryptedFileInput,
            openMainMenu,
            pageLoading
        };
    },
});
</script>

<style scoped>
ion-header.menu-header {
    height: calc(56px + var(--ion-safe-area-top));  
    border:none;
    color:var(--color-primary);
}

ion-header ion-toolbar:first-of-type {
    padding-top: var(--ion-safe-area-top); 
}

.nav-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.home-image {
    margin-left: 20px;
    margin-right: 20px;
    font-size: 25px;
    color: var(--color-primary);
}

.left-home-image {
    margin-left: 12px;
    margin-right: 20px;
    margin-right: 20px;
    font-size: 25px;
}

.left-home-image {
    margin-left: 12px;
    margin-right: 20px;
    font-size: 25px;
}

ion-icon.title-image {
    color: var(--color-primary);
}

.title-image {
    text-align: center;
    font-size: 30px;
    
    
}

.nav-title {
    /* text-align: center;*/
    /* text-align: center;*/
    font-size: 18px;
}

.calculator-icon-visible {
    visibility: visible;
}

.calculator-icon-hidden {
    visibility: hidden;
}

.calculator-icon-visible {
    visibility: visible;
}

.calculator-icon-hidden {
    visibility: hidden;
}

.title-container {
   text-align: center;
}

.home-title-container {
   text-align: center;
}

.home-title-container {
    display: inline-flex;
    margin-left: 6px;
    margin-left: 6px;
}

.image-and-text-title-container {
    vertical-align: middle;
}
.image-and-text-title-container span {
    font-size: 18px;
    font-weight: bold;
    line-height: 25px;
}

.image-and-text-title-container .title-image {
    font-size: 25px;
    margin: 0 5px;
}

.image-and-text-title-container span {
    margin: 0 5px;
}


.menu-header {
    z-index: 1001;
}

/* NEED TO DECLARE THESE EMPTY CLASSES TO ACCESS CSS SHADOW PARTS*/
.menu-row {
}
.menu-row::part(native),
.sub-menu-row::part(native) {
    --border-color: var(--ion-color-custom-step-700);
}

.sub-menu-row {
    --background: var(--color-app-background);
}

.menu-list {
    padding: 0;
}

.custom-menu {
    --width: 300px;
    padding: 0;
}

.custom-menu::part(container) {
    top: calc(56px + var(--ion-safe-area-top));
}

/* NEED TO DECLARE THESE EMPTY CLASSES TO ACCESS CSS SHADOW PARTS*/
.menu-content {
}
.menu-content::part(scroll) {
    padding-top: 0;
}

.menu-image {
    margin: 0 25px;
    flex-basis: 25px;
    flex-grow: 0;
    flex-shrink: 0;
}

.menu-text {
    width: 100%;
    font-size: 18px;
    color: var(--ion-color-custom-step-250);
    font-weight: 400;
    text-align: start;
}

.menu-item {
    display: flex;
    align-items: center;
    width: 100%;
}

.sub-menu-item {
    display: flex;
    align-items: center;
    width: 100%;
}

.sub-menu-item .menu-image {
    margin: 0 25px 0 45px;
}

.icon {
    color: var(--color-primary);
    font-size: 25px;
}

ion-menu-button::part(icon) {
    font-size: 30px;
}

.close-icon {
    color: var(--ion-color-custom-step-1000);
    font-size: 40px;
}
.hidden-input {
    display: none;
}
</style>
